import React from 'react';
import { Constants } from './../Core/Constants'

const PasswordChanged = () => {
    let T = window.Texts.login;
    return (
        <div className="lost-password-page">
            <div className="cover">
                <div className="headline">
                    <h1>{T.passwordChangedTitle}</h1>
                </div>
                <div className="inner-500">
                    <p /><p>{T.dearCustomer}</p>
					<p>passwordChangedTextAlreadyLogin</p>
                </div>
            </div>
        </div>
    );
};

export default PasswordChanged;